import React from 'react';
import styles from './GradientText.module.css';

interface GradientTextProps {
  children: React.ReactNode;
  className?: string;
}

export const GradientText: React.FC<GradientTextProps> = ({
  children,
  className,
}) => {
  return (
    <span className={`${styles.gradientText} ${className || ''}`}>
      {children}
    </span>
  );
};
